export default "__VITE_ASSET__C_3$J7ov__"